import '../sections/products-carousel';
import '../sections/info-banner-carousel';
import '../sections/blog-carousel';
import '../../sass/layout/sections/about-us-banner.scss';
import '../sections/IG-carousel';
import '../sections/layers-earth';
import '../../sass/layout/page/page-home.scss';

import Swiper, {
    Navigation,
    Pagination,
    Autoplay,
    EffectFade
} from 'swiper';
import myLazyLoad from '../vendors/lazyLoading';

const mainCarousel = document.getElementById('main-banner');

if (mainCarousel) {
    const pagination = mainCarousel.querySelector('.swiper-pagination');
    const nextEl = mainCarousel.querySelector('.swiper-button-next');
    const prevEl = mainCarousel.querySelector('.swiper-button-prev');

    const options = {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        loop: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 1000,
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        autoplay: false,
        autoplay: {
            delay: 5000,
        },
        init: true,
    }


    const swiper = new Swiper(mainCarousel, options);

    (function(){
        const videos =  mainCarousel.querySelectorAll(`video`); 
        if(videos) {
            videos.forEach(video => {
                var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                if (1024 > w) {
                    video.querySelector("source").setAttribute('src', `${video.dataset.mobile}`);
                } else {
                    video.querySelector("source").setAttribute('src', `${video.dataset.desktop}`);
                }
                video.load();
                video.play();
            })
        }
      })();

    swiper.on('init', function () {
        setTimeout(() => {
            const currentVideo = mainCarousel.querySelector(`.swiper-slide-active video`);
            if (currentVideo) {
                swiper.autoplay.stop();
                currentVideo.play();

                currentVideo.addEventListener('ended', function () {
                    currentVideo.pause();
                    swiper.slideNext();
                    swiper.autoplay.start();
                }, false);
            }
        }, 500)
    })

    const sliderVideos = mainCarousel.querySelectorAll(".swiper-slide video");

    swiper.init();

    swiper.on('slideChange', function (swiper) {
        myLazyLoad.update();
        
        setTimeout(function () {
            var currentVideo = mainCarousel.querySelector(`.swiper-slide-active video`);
            if (currentVideo) {
                sliderVideos.forEach(video => {
                    video.pause();
                    video.currentTime = 0;
                    video.muted = 0;
                })
                swiper.autoplay.stop();
                currentVideo.muted = 0;
                currentVideo.play();
                currentVideo.addEventListener('ended', function () {
                    currentVideo.pause();
                    swiper.slideNext();
                    swiper.autoplay.start();
                }, false);
            }
        }, 1000)
    });


}

